(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.inputs.address-autocomplete'
  const { Loader } = require('@googlemaps/js-api-loader')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap')
    ])
    .run(addressAutocompleteConfig)

  addressAutocompleteConfig.$inject = ['formlyConfig']
  function addressAutocompleteConfig (formlyConfig) {
    formlyConfig.setType({
      name: 'address-autocomplete',
      extends: 'input',
      controller: addressAutocompleteController,
      defaultOptions: {},
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    })
  }

  addressAutocompleteController.$inject = ['$scope']
  function addressAutocompleteController ($scope) {
    let service = null
    const loader = new Loader({
      apiKey: 'AIzaSyDuhJJWjV5LffJbmZCo3p_huh1O94wElqY',
      version: 'weekly',
      libraries: ['places']
    })

    loader.load().then((google) => {
      $scope.$apply()

      service = new google.maps.places.Autocomplete($scope.fc.$$element[0], {
        componentRestrictions: { country: ['us'] },
        fields: ['address_components', 'geometry'],
        types: ['address']
      })
      service.addListener('place_changed', onPlaceChanged)
    }).catch(e => {
      console.error('Failed to load Google Maps API:', e)
      $scope.$apply()
    })

    function onPlaceChanged () {
      const place = service.getPlace()
      let streetNumber, street, city, state, zipcode

      for (const component of place.address_components) {
        const componentType = component.types[0]

        switch (componentType) {
          case 'street_number':
            streetNumber = component.long_name
            break

          case 'route':
            street = component.short_name
            break

          case 'postal_code':
            zipcode = component.long_name
            break

          case 'locality':
            city = component.long_name
            break

          case 'administrative_area_level_1':
            state = component.short_name
            break
        }
      }

      $scope.$applyAsync(function () {
        if ($scope.to.display === 'single') {
          $scope.model[$scope.options.key] = `${streetNumber} ${street} ${city}, ${state} ${zipcode}`
        } else {
          $scope.model[$scope.options.key] = `${streetNumber} ${street}`
          $scope.model[$scope.options.key + '_city'] = city
          $scope.model[$scope.options.key + '_state'] = state
          $scope.model[$scope.options.key + '_zipcode'] = zipcode
        }
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/address-autocomplete.js